import { Category1Types } from 'enums/category1Enums';
import { FormType } from 'enums/FieldTypeEnums';
import React, { FC, useContext } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import FieldsRow from 'shared/components/FieldsRow';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import { ScopeThreeCategoryOne } from 'models/ScopeThreeCategoryOne/ScopeThreeCategoryOne.model';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { getOriginsData } from '../getOrigindata';
import { BestFitRegion } from 'models/BestFitRegion/bestFitRegion.model';

interface OriginsLayoutProps {
  index: number;
  type: Category1Types;
  originIndex: number;
  removeOrigin?: (index?: number) => void;
  bestFitRegion?: BestFitRegion[];
  setValue?: UseFormSetValue<ScopeThreeCategoryOne>;
  setIsAddRegion?: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  originsLength?: number;
  isDisabled?: boolean;
  handleOriginShare?: () => void;
}

const OriginsLayout: FC<OriginsLayoutProps> = ({
  bestFitRegion,
  ...remainingProps
}) => {
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const orginsData = getOriginsData({
    bestFitRegionOptions: bestFitRegion,
    fetchData,
    ...remainingProps,
  });
  return <FieldsRow {...orginsData} formType={FormType.REACT_HOOK_FORMS} />;
};

export default OriginsLayout;
